import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      background: colors.white.lightest,
      borderTop: '1px solid #EAECF0', // TODO replace after creating new palette
      flexDirection: 'column',
      gap: spacing(2),
      padding: spacing(4, 6),
      borderBottomLeftRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
    },
    actions: {
      display: 'flex',
      gap: spacing(2),
      justifyContent: 'space-between',
      width: '100% !important',
    },
    actionsLeft: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: spacing(2),
    },
    actionsRight: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: spacing(2),
    },
    error: {
      color: colors.red.darkish,
      margin: spacing(0, 0, 2, 2),
    },
  });
